import React from 'react'
import Sidebar from "../components/sidebar";
import Header from '../components/Header';
import Subscription from '../components/Subscription/Subscription'

function SubscriptionScreen() {

  return (
    <>
        <Sidebar />
        <main className="main-wrap">
            <Header />
                <Subscription />
        </main>
    </>
  )
}

export default SubscriptionScreen